<template>
  <div>
    <exo-input-ref-notparametric
      :root="_self"
      name="spaceObject"
      type="spaceObject"
      componentRoute="/spaceobject"
    />

    <v-col cols="">
      <exo-input-checkbox :root="_self" name="extendedBalisticAnalysisNeeded">
        <exo-help-dialog
          :color="'white--text'"
          :margin="'ma-20'"
          title="Analysis Type"
        >
          <tooltipAnalysisType />
        </exo-help-dialog>
      </exo-input-checkbox>
    </v-col>
  </div>
</template>

<script>
import formMixin from '../../mixins/forms.js'
import numericalMixin from '../../mixins/numericalForms.js'
import tooltipAnalysisType from '../../components/Tooltips/Defense/tooltipAnalysisType'

export default {
  name: 'maneuverAnalysisForm',

  components: {
    tooltipAnalysisType
  },

  props: {
    analysisrequest: {
      type: Object,
      default: () => null
    }
  },

  watch: {
    spaceObject: {
      handler(newValue) {
        this.$emit('update:analysisrequest', this.createObjectFromForm())
      },
      deep: true
    },
    extendedBalisticAnalysisNeeded: {
      handler(newValue) {
        this.$emit('update:analysisrequest', this.createObjectFromForm())
      },
      deep: true
    },
    analysisrequest: {
      handler(newValue) {
        if (newValue != null) {
          this.edit(newValue, 0)
        }
      },
      deep: true
    },
    inputsValid: {
      handler(newValue) {
        this.$emit('updateValidation', newValue)
      }
    }
  },

  mixins: [formMixin, numericalMixin],

  mounted() {
    this.refreshSpaceObjects()
  },

  computed: {
    spaceObject() {
      return this.inputs.spaceObject
    },
    extendedBalisticAnalysisNeeded() {
      return this.inputs.extendedBalisticAnalysisNeeded
    }
  },

  data() {
    return {
      enumPropertiesList: this.getEnumProperties(),
      inputs: {
        name: 'maneuverAnalysisRequest',
        spaceObject: null,
        measurements: null,
        extendedBalisticAnalysisNeeded: this.getDefaultValue(
          'extendedBalisticAnalysisNeeded'
        ),
        type: this.getDefaultValue('type')
      },
      spaceObjectsNotParametrics: null,
      enableFormCache: false
    }
  },

  methods: {
    getCurrentFormType() {
      return 'ManeuverAnalysisRequest'
    },

    refreshTable() {},

    refreshSpaceObjects() {
      let self = this
      this.$http
        .get(this.getAPI('spaceobjectdefinitions'))
        .then((response) => {
          self.spaceObjectsNotParametrics = response.data
            .filter((obj) => !obj.displayedName.endsWith('*'))
            .map((obj) => ({ value: obj, text: obj.displayedName }))
            .sort((a, b) =>
              a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1
            )
        })
        .catch((e) => {
          self.displayMessage(
            'Error getting list of space objects. ',
            e,
            'NumericalMissionErrorDisplay',
            'error'
          )
        })
    }
  }
}
</script>
